import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { auth, getApiError } from '../../api/client';
import { useAuth } from '../../contexts/AuthContext';
import { usePos } from '../../contexts/PosContext';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import { LogoMark } from '../../components/common/Logo';

export default function Login() {
  const { login } = useAuth();
  const { isPos } = usePos();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [needsConfirmation, setNeedsConfirmation] = useState(false);
  const [resending, setResending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setNeedsConfirmation(false);
    try {
      const res = await auth.login(form);
      login(res.data);
      navigate('/');
    } catch (err) {
      if (err.response?.status === 403 && err.response?.data?.emailNotConfirmed) {
        setNeedsConfirmation(true);
      }
      setError(getApiError(err, 'Gabim gjatë kyçjes.'));
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setResending(true);
    try {
      await auth.resendConfirmation(form.email);
      toast.success('Email-i i konfirmimit u ridërgua.');
    } catch {
      toast.error('Nuk u dërgua dot email-i. Provo përsëri.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f1f5f9' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 40, width: '100%', maxWidth: 400, boxShadow: '0 4px 24px #00000015', border: '1px solid #e5e7eb' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ display: 'inline-flex', marginBottom: 12 }}>
            <LogoMark size={48} />
          </div>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700, color: '#111827' }}>StockFlow</h1>
          <p style={{ margin: '4px 0 0', color: '#6b7280', fontSize: 14 }}>Kyçu në llogarinë tënde</p>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {error && <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: '10px 12px', color: '#dc2626', fontSize: 13 }}>{error}</div>}
          {needsConfirmation && (
            <button type="button" onClick={handleResend} disabled={resending}
              style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 8, padding: '10px 12px', color: '#1d4ed8', fontSize: 13, fontWeight: 600, cursor: resending ? 'not-allowed' : 'pointer', textAlign: 'left' }}>
              {resending ? 'Duke dërguar…' : 'Ridërgo email-in e konfirmimit'}
            </button>
          )}
          <Input label="Email" type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required placeholder="email@kompania.com" />
          <Input label="Fjalëkalimi" type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required placeholder="••••••••" />
          {/* A till has neither: resetting a password needs the email that the office holds, and a
              new company is never registered from a shop counter. */}
          {!isPos && (
            <div style={{ textAlign: 'right', marginTop: -6 }}>
              <Link to="/forgot-password" style={{ color: '#3b82f6', textDecoration: 'none', fontSize: 13, fontWeight: 500 }}>Harruat fjalëkalimin?</Link>
            </div>
          )}
          <Button type="submit" loading={loading} size="lg" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}>
            Kyçu
          </Button>
        </form>

        {isPos ? (
          <p style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: '#6b7280' }}>
            Kyçu me të njëjtat kredenciale si në zyrën qendrore. Punon edhe pa internet.
          </p>
        ) : (
          <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14, color: '#6b7280' }}>
            Nuk ke llogari?{' '}
            <Link to="/register" style={{ color: '#3b82f6', textDecoration: 'none', fontWeight: 500 }}>Regjistro kompaninë</Link>
          </p>
        )}
      </div>
    </div>
  );
}
